/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./wrapper.vue?vue&type=template&id=d52291f0&scoped=true"
import script from "./wrapper.vue?vue&type=script&lang=js"
export * from "./wrapper.vue?vue&type=script&lang=js"
import style0 from "./wrapper.vue?vue&type=style&index=0&id=d52291f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52291f0",
  null
  
)

export default component.exports